/* ==========================================================================
   Plant Store <> UnfoldCRO — Product card behaviour
   Variant chips (swap price + variant id) and AJAX add-to-cart with the
   design's "Added" confirmation state.

   Also used by the cart drawer's upsell rail, which loads this file too —
   hence the bind-once guard.
   ========================================================================== */
(function () {
  'use strict';

  if (window.ufcProductCardBound) return;
  window.ufcProductCardBound = true;

  var ADDED_MS = 2000;

  // Shopify serves every size from the same URL, so the responsive set for a
  // swapped image is the same URL with its width swapped. Rebuilt rather than
  // shipped per chip, which would have put five URLs in the markup for every
  // value of every card on the page.
  var IMAGE_WIDTHS = [200, 300, 400, 600, 800];

  function srcsetFor(url) {
    if (!/[?&]width=\d+/.test(url)) return '';
    return IMAGE_WIDTHS.map(function (w) {
      return url.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w';
    }).join(', ');
  }

  function selectChip(card, chip) {
    // Only the pill control carries aria-checked; a <select> tracks its own
    // selection, so this sweep simply finds nothing in dropdown mode.
    var chips = card.querySelectorAll('[data-ufc-chip]');
    Array.prototype.forEach.call(chips, function (other) {
      other.setAttribute('aria-checked', other === chip ? 'true' : 'false');
    });

    card.setAttribute('data-variant-id', chip.getAttribute('data-variant-id') || '');

    var price = card.querySelector('[data-ufc-card-price]');
    var compare = card.querySelector('[data-ufc-card-compare]');
    var off = card.querySelector('[data-ufc-card-off]');

    // Prices are pre-formatted by Liquid so the shop's money format is used
    // verbatim — reformatting client-side would drift from the server render.
    var priceCents = chip.getAttribute('data-price');
    var compareCents = chip.getAttribute('data-compare');

    if (price) price.textContent = chip.getAttribute('data-price-formatted') || price.textContent;

    var hasCompare = compareCents && Number(compareCents) > Number(priceCents);

    if (compare) {
      compare.hidden = !hasCompare;
      if (hasCompare) compare.textContent = chip.getAttribute('data-compare-formatted') || '';
    }

    if (off) {
      off.hidden = !hasCompare;
      if (hasCompare) {
        var pct = Math.round((1 - Number(priceCents) / Number(compareCents)) * 100);
        off.textContent = '-' + pct + '%';
      }
    }

    // The photo follows the choice, where that variant has one of its own; a
    // variant without an image keeps whatever the card is already showing
    // rather than falling back to the product's first photo.
    // Addressed by where it sits rather than by an attribute of its own:
    // image_tag drops an argument whose name carries a hyphen, and takes the
    // rest of the argument list with it.
    var image = card.querySelector('.ufc-card__media img');
    var source = chip.getAttribute('data-image');
    if (image && source) {
      image.setAttribute('srcset', srcsetFor(source));
      image.setAttribute('src', source);
      var alt = chip.getAttribute('data-image-alt');
      if (alt) image.setAttribute('alt', alt);
    }

    // Both the image and the title lead to the product with this variant
    // preselected, so the page opens on what the shopper picked here.
    var url = card.getAttribute('data-url');
    var variantId = chip.getAttribute('data-variant-id');
    if (url && variantId) {
      // On a search page the product url already carries its own tracking
      // query, so the separator has to be worked out rather than assumed.
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      Array.prototype.forEach.call(card.querySelectorAll('[data-ufc-card-link]'), function (link) {
        link.setAttribute('href', url + sep + 'variant=' + variantId);
      });
    }

    var add = card.querySelector('[data-ufc-add]');
    if (add) {
      var available = chip.getAttribute('data-available') !== 'false';
      add.disabled = !available;
      add.textContent = available
        ? card.getAttribute('data-add-label') || 'Add to cart'
        : card.getAttribute('data-soldout-label') || 'Sold out';
    }
  }

  // Refreshing the source bubble is enough — ufc-header.js mirrors it into
  // the mobile badge through its MutationObserver.
  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;
        var count = String(cart.item_count);
        var source = document.querySelector('#cart-icon-bubble [data-ufc-cart-count]');
        if (source) {
          source.textContent = count;
          source.hidden = cart.item_count === 0;
        }
        var mirrors = document.querySelectorAll('[data-ufc-cart-mirror]');
        Array.prototype.forEach.call(mirrors, function (target) {
          target.textContent = count;
          target.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  function addToCart(card, button) {
    var variantId = card.getAttribute('data-variant-id');
    if (!variantId || button.disabled) return;

    var idleLabel = card.getAttribute('data-add-label') || 'Add to cart';
    var addedLabel = card.getAttribute('data-added-label') || 'Added';

    // Ask for the drawer's own sections so Dawn can re-render and open it.
    var drawer = document.querySelector('cart-drawer');
    var canRender = !!(drawer && typeof drawer.renderContents === 'function');
    var sectionIds = ['cart-icon-bubble'];
    if (canRender && typeof drawer.getSectionsToRender === 'function') {
      sectionIds = drawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }

    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(function (data) {
        button.classList.add('is-added');
        button.textContent = addedLabel;
        if (!(window.ufcCartHandledByApp && window.ufcCartHandledByApp())) {
          if (canRender && data && data.sections && drawer.isConnected) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(data);
          } else {
            refreshCartCount();
          }
        }
        // if (canRender && data && data.sections) {
        //   // renderContents() only swaps #CartDrawer's innerHTML, so the
        //   // `is-empty` flag Dawn keeps on the <cart-drawer> HOST survives —
        //   // leaving a freshly-filled cart rendered in its empty layout.
        //   // The cart is non-empty by definition here, so clear it first.
        //   drawer.classList.remove('is-empty');
        //   drawer.renderContents(data);
        // } else {
        //   refreshCartCount();
        // }

        window.clearTimeout(card.ufcAddedTimer);
        card.ufcAddedTimer = window.setTimeout(function () {
          button.classList.remove('is-added');
          button.textContent = idleLabel;
          button.disabled = false;
        }, ADDED_MS);
      })
      .catch(function () {
        button.textContent = card.getAttribute('data-error-label') || 'Try again';
        window.setTimeout(function () {
          button.textContent = idleLabel;
          button.disabled = false;
        }, ADDED_MS);
      });
  }

  // The dropdown carries the same data attributes on its <option>s, so the
  // selected option can be handed to the very same routine the pills use.
  // Delegated on change for the same reason the click handler is: cards arrive
  // after load from the editor, the upsell rail and paginated grids.
  document.addEventListener('change', function (event) {
    var select = event.target.closest ? event.target.closest('[data-ufc-chip-select]') : null;
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var card = select.closest('[data-ufc-card]');
    if (option && card) selectChip(card, option);
  });

  // Delegated so cards rendered later (section reload in the theme editor,
  // the cart drawer's upsell rail, paginated grids) work without re-binding.
  document.addEventListener('click', function (event) {
    var chip = event.target.closest ? event.target.closest('[data-ufc-chip]') : null;
    if (chip) {
      event.preventDefault();
      var chipCard = chip.closest('[data-ufc-card]');
      if (chipCard) selectChip(chipCard, chip);
      return;
    }

    var button = event.target.closest ? event.target.closest('[data-ufc-add]') : null;
    if (!button) return;
    event.preventDefault();
    var card = button.closest('[data-ufc-card]');
    if (card) addToCart(card, button);
  });
})();
